import React from 'react';
import { ResearcherEvaluation } from '../../types';
import styles from './EvaluationDetailsGrid.module.css';

interface EvaluationDetailsGridProps {
  evaluation: ResearcherEvaluation;
  showEvaluatorInfo?: boolean;
  evaluatorName?: string;
  evaluatorEmail?: string;
  isExternal?: boolean;
  assignedAt?: string;
  assignmentStatus?: string;
}

const EvaluationDetailsGrid: React.FC<EvaluationDetailsGridProps> = ({
  evaluation,
  showEvaluatorInfo = false,
  evaluatorName,
  evaluatorEmail,
  isExternal,
  assignedAt,
  assignmentStatus,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('es-CL', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={styles.evaluationsSection}>
      <h2>Detalles Adicionales</h2>
      <div className={styles.detailsGrid}>
        <div className={styles.detailCard}>
          <h3>Comentarios Presupuestarios</h3>
          <div className={styles.detailContent}>
            {evaluation.budgetComments ? (
              <div className={styles.commentsText}>
                <p>{evaluation.budgetComments}</p>
              </div>
            ) : (
              <p>Sin comentarios al presupuesto.</p>
            )}
          </div>
        </div>

        <div className={styles.detailCard}>
          <h3>Comentarios Generales</h3>
          <div className={styles.detailContent}>
            {evaluation.overallComments ? (
              <div className={styles.commentsText}>
                <p>{evaluation.overallComments}</p>
              </div>
            ) : (
              <p className={styles.noComments}>Sin comentarios generales</p>
            )}
          </div>
        </div>

        {showEvaluatorInfo && evaluatorName && (
          <div className={styles.detailCard}>
            <h3>Información del Evaluador</h3>
            <div className={styles.detailContent}>
              <p><strong>Nombre:</strong> {evaluatorName}</p>
              <p><strong>Email:</strong> {evaluatorEmail}</p>
              <p><strong>Tipo:</strong> {isExternal ? 'Evaluador Externo' : 'Evaluador UC'}</p>
              {assignmentStatus && (
                <p><strong>Estado de asignación:</strong> {assignmentStatus}</p>
              )}
              {assignedAt && (
                <p><strong>Asignado el:</strong> {formatDate(assignedAt)}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EvaluationDetailsGrid;